import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { IntelligenceAnalyticsEffects } from './intelligence-analytics-effects.service';

@NgModule({
  imports: [EffectsModule.forFeature([IntelligenceAnalyticsEffects])],
})
export class IntelligenceAnalyticsDataModule {}
